function bg_to_src(bg){

    return bg.replace('url(','').replace(')','').replace(/\"/gi, "");

}